export default __webpack_public_path__ + "static/img-5-ff8f2f4d5ea30baec7ed94086ef89bd1.png";